/*
 Inline Signup
 <div id="signupBox" class="hidden"
	 data-title = "<?=_('Registrieren')?>"
	 data-btn-text = "<?=_('Jetzt Registirieren')?>"
	 data-username-title = "<?=_('Benutzername')?>"
	 data-username-placeholder = "<?=_('Wie willst du heissen?')?>"
	 data-email-title = "<?=_('E-Mail')?>"
	 data-email-placeholder = "<?=_('Deine E-Mail Adresse')?>"
	 data-action-url = "<?=$this->targetUrl?>"
	 data-animate = "0"
	 data-login-link-title = "<?=_('Schon registriert?')?>"
	 data-login-link-text = "<?=_('Hier einloggen')?>"
	 data-error-00 = "<?=_('Bitte gib deinen Benutzernamen an')?>"
	 data-error-01 = "<?=_('mind. 6 Zeichen, keine Sonderzeichen')?>"
	 data-error-10 = "<?=_('Bitte gib deine E-Mail an')?>"
	 data-error-11 = "<?=_('Ungültige E-Mail Adresse')?>"
	 data-error-0x01 = "<?=_('Ungültiger Username')?>"
	 data-error-0x02 = "<?=_('Username ist bereits vergeben')?>"
	 data-error-0xl0 = "<?=_('Ungültige E-Mail-Adresse')?>"
	 data-error-0x20 = "<?=_('E-Mail-Adresse fehlerhaft oder blockiert')?>"
	 data-error-0x40 = "<?=_('Bitte überprüfe deine E-Mail-Adresse auf Tippfehler')?>"
	 data-error-0x80 = "<?=_('E-Mail-Adresse ist bereits vergeben')?>"
	 ></div>
 */
let showInlineSignupBoxFn;
let displayInlineSignupBoxFn;
export { showInlineSignupBoxFn, displayInlineSignupBoxFn };

;if (typeof(Zepto) !== 'undefined' || typeof(jQuery) !== 'undefined') {
	var validateTimer = null;
	
	/**
	 * Initialize SignupBox
	 * If #signupBox has class hidden, use displayInlineSignupBox() to show box
	 */
	function showInlineSignupBox() {
		var $signupBox  		= $('#signupBox');
		var laDomain    		= $signupBox.data('product-domain')   ? $signupBox.data('product-domain')   : '//www.lustagenten.com';
		var loginTitle  		= $signupBox.data('login-link-title') ? $signupBox.data('login-link-title') : '';
		var loginLink   		= $signupBox.data('login-link-text')  ? $signupBox.data('login-link-text')  : '';
		var targetUrl 			= $signupBox.data('targetUrl') ? $signupBox.data('targetUrl') : '';
		var animate     		= parseInt($signupBox.data('animate'));
		var errors = {
			'00': $signupBox.data('error-00') ? $signupBox.data('error-00') : 'Bitte gib deinen Benutzernamen an',
			'01': $signupBox.data('error-01') ? $signupBox.data('error-01') : 'mind. 6 Zeichen, keine Sonderzeichen',
			'10': $signupBox.data('error-10') ? $signupBox.data('error-10') : 'Bitte gib deine E-Mail an',
			'11': $signupBox.data('error-11') ? $signupBox.data('error-11') : 'Ungültige E-Mail Adresse',
			'20': $signupBox.data('error-20') ? $signupBox.data('error-20') : 'Diese Namen sind noch frei',
			'0x01': $signupBox.data('error-0x01') ? $signupBox.data('error-0x01') : 'Ungültiger Username',
			'0x02': $signupBox.data('error-0x02') ? $signupBox.data('error-0x02') : 'Username ist bereits vergeben',
			'0xl0': $signupBox.data('error-0xl0') ? $signupBox.data('error-0xl0') : 'Ungültige E-Mail-Adresse',
			'0x20': $signupBox.data('error-0x20') ? $signupBox.data('error-0x20') : 'E-Mail-Adresse fehlerhaft oder blockiert',
			'0x40': $signupBox.data('error-0x40') ? $signupBox.data('error-0x40') : 'Bitte überprüfe deine E-Mail-Adresse auf Tippfehler',
			'0x80': $signupBox.data('error-0x80') ? $signupBox.data('error-0x80') : 'E-Mail-Adresse ist bereits vergeben'
		};
		window.userEmail = $signupBox.data('user-email') ? $signupBox.data('user-email') : '';
		window.lastCheck = '';
		window.suggestionTimer = null;

		// if mobile traffic (wap traffic) detected, skip login and redirect to product page
		if (typeof _ismt !== 'undefined' && _ismt === 1) {
			if (!$signupBox.hasClass('hidden')) {  // may be initialized but not yet triggered
				window.setTimeout(function() {
					window.location.href = $signupBox.data('action-url').replace("/registrieren/0", "");
				}, 2000);
			}
			return false;
		}

		window.validateCheck = function (isSubmit, showNameError, showMailError) {
			isSubmit = typeof(isSubmit) !== 'undefined' ? isSubmit : false;
			var laUrl = targetUrl;
			//var laUrl = 'http://af.lustagenten.x/interface/checkUser3/';
			var regexUser = /^[a-zA-Z0-9]{6,}$/;
			var regexMail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			var username = $('#username').val();
			var email = $('#email').val();

			if (!isSubmit && window.lastCheck === username + '|' + email) {  //don't repeat same request
				return;
			}
			window.lastCheck = username + '|' + email;

			var errorName = null;
			var errorMail = null;
			showNameError = typeof(showNameError) !== 'undefined' ? showNameError : false;
			showMailError = typeof(showMailError) !== 'undefined' ? showMailError : false;
			var nameSuggestions = null;

			// logical checks
			if (username === null || username === "" || username.length < 6) {
				errorName = errors['00'];  //'Bitte gib deinen Benutzernamen an';
				if (isSubmit) {
					showNameError = true;
				}
			}
			else if (username.length < 6 || !(regexUser.test(username))) {
				errorName = errors['01'];  //'mind. 6 Zeichen, keine Sonderzeichen';
				if (isSubmit || username.length > 5 || !(/^[a-zA-Z0-9]{1,}$/.test(username))) {
					showNameError = true;
				}
			}

			if (email === null || email === "" || email.length < 1) {
				errorMail = errors['10'];  //'Bitte gib deine E-Mail an';
				if (isSubmit) {
					showMailError = true;
				}
			}
			else if (email.length < 5 || !(regexMail.test(email))) {
				errorMail = errors['11'];  //'Ungültige E-Mail Adresse';
				if (isSubmit || regexMail.test(email)) {
					showMailError = true;
				}
			}

			// check against lustagenten
			if (errorName == null || errorMail === null) {
				$.ajax({
					url: laUrl + '?jscall=JSON&user_name=' + encodeURIComponent(username) + '&user_email=' + encodeURIComponent(email),
					context: window,
					complete: function (xhr) {  //$.ajax(...).always(.. would require Zepto modules “callbacks” and “deferred”
						
						if(isSubmit && username.length >= 6){
							$('#register').submit();
						}

						if (xhr.status !== 200) {
							return;
						}
						var response = $.parseJSON(xhr.response);

						if (!response.success) {
							return;
						}

						var result = response.data.status;

						if (result & 0x01) {
							errorName = errors['0x01'];  //'Ungültiger Username';
							if (isSubmit || showNameError) {
								showNameError = true;
							}
						} else if (result & 0x02) {
							errorName = errors['0x02'];  //'Username ist bereits vergeben';
							showNameError = true;
							nameSuggestions = response.data['userNameSuggestions'];
						}
						if (result & 0x10) {
							errorMail = errors['0x10'];  //'Ungültige E-Mail-Adresse';
							if (isSubmit) {
								showMailError = true;
							}
						} else if (result & 0x20) {
							errorMail = errors['0x20'];  //'E-Mail-Adresse fehlerhaft oder blockiert';
							showMailError = true;
						} else if (result & 0x40) {
							errorMail = errors['0x40'];  //'Bitte überprüfe deine E-Mail-Adresse auf Tippfehler';
							showMailError = true;
						} else if (result & 0x80) {
							errorMail = errors['0x80'];  //'E-Mail-Adresse ist bereits vergeben';
							showMailError = true;
						}
						if (isSubmit && errorName === null && errorMail === null) {
							$('#register').submit();
						} else {
							if (window.userEmail !== '' && showMailError) {
								window.slideDown();
							}
							window.setErrors(errorName, errorMail, showNameError, showMailError, nameSuggestions);
						}
					}
				});
			} else {
				window.setErrors(errorName, errorMail, showNameError, showMailError, nameSuggestions);
			}

			if (errorName === null) {
				if (window.userEmail === '' || errorMail !== null) {
					window.slideDown();
				}
			}

			return (errorName === null && errorMail === null);
		};

		window.slideDown = function() {
			if (typeof($('#emailBlock').slideDown) == 'function') {
				$('#emailBlock').slideDown();
			} else {
				$('#emailBlock').css('display', 'block');
			}
		};

		window.showSuggestions = function(nameSuggestions) {
			if (typeof ga.getByName('lustagentenTracker') !== 'undefined') {
				ga('lustagentenTracker.send', 'event', 'Member', 'UserNameSuggestions', 'show');
			}
			var suggestionBlock = $('<div>', {
				id: 'nameSuggestionBlock'
			});
			$('#usernameBlock').after(suggestionBlock);

			var suggestionHeader = $('<div>', {
				class: 'nameSuggestionHeader',
				html: errors['0x02'] + '<br/>' + errors['20'] + ':'
			}).appendTo(suggestionBlock);

			$.each(nameSuggestions, function (idx, text) {
				$('<div>', {
					class: 'nameSuggestion',
					text: text,
					onClick: '$("#username").val("' + text + '"); $("#nameSuggestionBlock").remove();'
				}).appendTo(suggestionBlock);
			});
		};

		window.setErrors = function (errorName, errorMail, showNameError, showMailError, nameSuggestions) {
			var $usernameBlock = $('#usernameBlock');
			if (errorName !== null && showNameError) {
				$usernameBlock.addClass('has-error');
				$usernameBlock.find('.help-block').html(errorName);
			} else {
				$usernameBlock.removeClass('has-error');
				$usernameBlock.find('.help-block').html('');
			}
			var $emailBlock = $('#emailBlock');
			if (errorMail !== null && showMailError) {
				$emailBlock.addClass('has-error');
				$emailBlock.find('.help-block').html(errorMail);
			} else {
				$emailBlock.removeClass('has-error');
				$emailBlock.find('.help-block').html('');
			}

			$('#nameSuggestionBlock').remove();  //remove old
			window.clearTimeout(window.suggestionTimer);
			if (nameSuggestions && nameSuggestions.length > 0) {
				window.suggestionTimer = window.setTimeout(function() {
					window.showSuggestions(nameSuggestions);
				}, 500);
			}
		};

		var htmlTpl = ''
			+ '<div class="inlineSignupBox">'
			+ 	'<h3>' + $signupBox.data('title') + '</h3>'
			+ 	'<div id="inlineSignupBoxForm">'
			+ 		'<form id="register" method="post" target="_top" action="' + $signupBox.data('action-url') + '">'
			+ 			'<div id="usernameBlock">'
			+ 				'<label for="username">' + $signupBox.data('username-title') + '</label>'
			+ 				'<div style="position: relative;">'
			+ 					'<i class="fa fa-user placeholder-icon" style="display: inline;"></i>'
			+					'<div id="error_user" class="error-msg"></div>'
			+ 					'<input class="form-control white" type="text" autocomplete="off" name="username" id="username" placeholder="' + $signupBox.data('username-placeholder') + '" minlength="6" required />'
			+ 					'<div class="popover_container">'
			+						'<div id="suggestions" popover></div>'
			+ 					'</div>'
			+				'</div>'
			+ 			'</div>'
			+ 			'<div id="nameSuggestionBlock" style="display: none;">'
			+ 				'<div class="nameSuggestionHeader"></div>'
			+ 				'<div class="nameSuggestion"></div>'
			+ 			'</div>'
			+ 			'<div id="emailBlock"' + (animate ? ' style="display: none;"' : '') + '>'
			+ 				'<label for="email">' + $signupBox.data('email-title') + '</label>'
			+ 				'<div style="position: relative;">'
			+ 					'<i class="fa fa-mailunread placeholder-icon" style="display: inline;"></i>'
			+					'<div id="error_email" class="error-msg"></div>'
			+ 					'<input class="form-control white" type="text" name="email" id="email" value="' + (window.userEmail != '' ? window.userEmail : '') + '" placeholder="' + $signupBox.data('email-placeholder') + '" />'
			+ 				'</div>'
			+ 			'</div>'
			+           '<p style="margin-bottom: 10px;">Mit einer Anmeldung erkl&auml;re ich mich mit <a href="https://www.lustagenten.com/agb/" target="_blank">den AGB</a> und den <a href="https://www.lustagenten.com/datenschutz/" target="_blank">Datenschutzbestimmungen</a> f&uuml;r den Dienst Lustagenten einverstanden.</p>'
			+ 			'<input type="hidden" value="-autogenerate-" name="password">'
			+ 			'<input id="acceptAGB" type="hidden" checked="checked" name="acceptAGB">'
			+ 			'<button id="signup" type="submit" style="margin-top: 5px;"><span>' + $signupBox.data('btn-text') + '</span></button>'
			+ 			'<div id="login-link"' + (loginLink == '' ? ' style="display: none;"' : '') + '>'
			+ 				loginTitle + ' <a href="' + laDomain + '/?login=1" target="_top">' + loginLink + '</a>'
			+ 			'</div>'
			+ 		'</form>'
			+ 	'</div>'
			+ '</div>';

		var afterCreateFunc = function () {
			var $form = $('#inlineSignupBoxForm form'),
				$signUpBox = $('#inlineSignupBox');

			// add events
			var $username = $('#username');
			var $email = $('#email');

			$username.keydown(function () {
				clearTimeout(validateTimer);
				validateTimer = window.setTimeout(function () {
					window.validateCheck(false);
				}, 400);
			});
			$email.keydown(function () {
				clearTimeout(validateTimer);
				validateTimer = window.setTimeout(function () {
					window.validateCheck(false, true);
				}, 400);
			});
			$username.blur(function () {
				clearTimeout(validateTimer);
				validateTimer = window.setTimeout(function () {
					window.validateCheck(false, true);
				}, 100);
			});
			$email.blur(function () {
				clearTimeout(validateTimer);
				validateTimer = window.setTimeout(function () {
					window.validateCheck(false, true, true);
				}, 100);
			});
			$('#signup').click(function () {
				clearTimeout(validateTimer);
				validateTimer = window.setTimeout(function () {
					window.validateCheck(true);
				});
				return false;
			});

			$('.placeholder-icon').each(function (idx, icon) {
				var input = $(icon).next();
				input.addClass('placeholder');
				$(icon).show();
				input.on('input', function (e) {
					if (input.val() === '') {
						$(icon).show();
						input.addClass('placeholder');
					}
					else {
						$(icon).hide();
						input.removeClass('placeholder');
					}
				});
			});

			$(document).trigger({
				type: 'domChange',
				detail: {}
			});
		};

		$signupBox.html(htmlTpl);
		afterCreateFunc();
		$signupBox.removeAttr('data-product-domain data-title data-btn-text data-username-title data-username-placeholder data-email-title data-email-placeholder data-email-placeholder data-action-url data-animate data-login-link-title data-login-link-text data-error-00 data-error-01 data-error-10 data-error-11 data-error-0x01 data-error-0x02 data-error-0xl0 data-error-0x20 data-error-0x40 data-error-0x80');

		$(window).scrollTop($(window).height());
	}

	/**
	 * Initialize SignupBox
	 */
	function displayInlineSignupBox() {
		if (typeof _ismt !== 'undefined' && _ismt === 1) {
			var $docBody = $(document.body);
			var bodyHtml = $docBody.html();
			$docBody.html('<div style="display: none;">' + bodyHtml + '</div>');
			$docBody.append('<h1>Seite wird geladen ...</h1>');
			window.location.href = $('#signupBox').data('action-url').replace("/registrieren/0", "");
			return false;
		} else {
			$('#signupBox').removeClass('hidden');
		}
	}

	window.showInlineSignupBox = showInlineSignupBox;
	window.displayInlineSignupBox = displayInlineSignupBox;
	showInlineSignupBoxFn = showInlineSignupBox;
	displayInlineSignupBoxFn = displayInlineSignupBox;
}
